import StringKey from "./StringKey";
import TextString from "./TextString";

export const models = {
    StringKey,
    TextString,
};
